import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { getProductLiftUrl, type ProductLiftUserData } from '../lib/productlift';

export default function FeedbackLink() {
  const { user } = useAuth();
  const [feedbackUrl, setFeedbackUrl] = useState<string>('#');

  useEffect(() => {
    const generateUrl = async () => {
      if (!user?.email) return;

      const userData: ProductLiftUserData = {
        email: user.email,
        uid: user.id,
        name: user.user_metadata.username || user.email
      };

      try {
        const url = await getProductLiftUrl(userData);
        setFeedbackUrl(url);
      } catch (error) {
        console.error('Error generating ProductLift URL:', error);
      }
    };

    generateUrl();
  }, [user]);

  if (!user) return null;

  const handleFeedbackClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // Prevent the default link behavior
    const popupWidth = 600;
    const popupHeight = 700;
    const left = window.screenX + (window.outerWidth - popupWidth) / 2;
    const top = window.screenY + (window.outerHeight - popupHeight) / 2;

    // Open a new popup window
    window.open(
      feedbackUrl,
      'FeedbackPopup',
      `width=${popupWidth},height=${popupHeight},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  };

  return (
    <a
      href={feedbackUrl}
      onClick={handleFeedbackClick}
      className="flex items-center gap-2 text-indigo-600 h3-font"
    >
      <MessageSquare className="w-5 h-5" />
      <span>Feedback</span>
    </a>
  );
}
